var state = {
  visible: false,
  callbackFunc: function callbackFunc() {},
  dataSet: {
    rows: []
  },
  width: '20rem'
};
var getters = {
  visible: function visible(state) {
    return state.visible;
  },
  callbackFunc: function callbackFunc(state) {
    return state.callbackFunc;
  },
  dataSet: function dataSet(state) {
    return state.dataSet;
  },
  width: function width(state) {
    return state.width;
  }
};
var mutations = {
  SET_VISIBLE: function SET_VISIBLE(state, visible) {
    state.visible = visible;
  },
  SET_CALLBACKFUNC: function SET_CALLBACKFUNC(state, func) {
    state.callbackFunc = func;
  },
  SET_DATA: function SET_DATA(state, data) {
    state.dataSet = data;
  },
  SET_WIDTH: function SET_WIDTH(state, width) {
    state.width = width;
  }
};
var actions = {
  open: function open(_ref, dataSet) {
    var commit = _ref.commit;
    commit('SET_VISIBLE', true);
    commit('SET_CALLBACKFUNC', dataSet.handleClick || dataSet.func);
    commit('SET_DATA', dataSet);
  },
  close: function close(_ref2) {
    var commit = _ref2.commit;
    commit('SET_VISIBLE', false);
  },
  submit: function submit(_ref3) {
    var state = _ref3.state,
      commit = _ref3.commit;
    state.callbackFunc(state.dataSet);
    commit('SET_VISIBLE', false);
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};